import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <TapTileGrid @activeTile={{this.selectedShortcut}} as |grid|>
  {{#each this.options key="id" as |option|}}
    {{#unless option.hidden}}
      <TapTile
        @icon={{option.icon}}
        @tileId={{option.id}}
        @activeTile={{grid.activeTile}}
        @onChange={{action "selectShortcut"}}
      >
        <div class="tap-tile-title">{{i18n option.label}}</div>
        <div class="tap-tile-date">{{option.timeFormatted}}</div>
      </TapTile>
    {{/unless}}

    {{#if option.isCustomTimeShortcut}}
      {{#if this.customDatetimeSelected}}
        <div class="control-group custom-date-time-wrap custom-input-wrap">
          <div class="tap-tile-date-input">
            {{d-icon "calendar-alt"}}
            <DatePickerFuture
              @value={{this.customDate}}
              @defaultDate={{this.defaultCustomDate}}
              @onSelect={{fn (mut this.customDate)}}
              @id="custom-date"
            />
          </div>
          <div class="tap-tile-time-input">
            {{d-icon "far-clock"}}
            <Input
              placeholder="--:--"
              id="custom-time"
              @type="time"
              class="time-input"
              @value={{this.customTime}}
            />
          </div>
        </div>
        <div class="control-group custom-date-time-wrap custom-relative-wrap">
          <label class="control-label" for="bookmark-relative-time-picker">
            {{i18n "relative_time_picker.relative"}}
          </label>
          <RelativeTimePicker
            @id="bookmark-relative-time-picker"
            @durationMinutes={{this.selectedDurationMins}}
            @onChange={{action "relativeTimeChanged"}}
          />
        </div>
      {{/if}}
    {{/if}}
  {{/each}}
</TapTileGrid>
*/
{
  "id": "w0pv6Y0A",
  "block": "[[[8,[39,0],null,[[\"@activeTile\"],[[30,0,[\"selectedShortcut\"]]]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"options\"]]],null]],null],\"id\",[[[41,[51,[30,2,[\"hidden\"]]],[[[1,\"      \"],[8,[39,4],null,[[\"@icon\",\"@tileId\",\"@activeTile\",\"@onChange\"],[[30,2,[\"icon\"]],[30,2,[\"id\"]],[30,1,[\"activeTile\"]],[28,[37,5],[[30,0],\"selectShortcut\"],null]]],[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"tap-tile-title\"],[12],[1,[28,[35,6],[[30,2,[\"label\"]]],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"tap-tile-date\"],[12],[1,[30,2,[\"timeFormatted\"]]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,2,[\"isCustomTimeShortcut\"]],[[[41,[30,0,[\"customDatetimeSelected\"]],[[[1,\"        \"],[10,0],[14,0,\"control-group custom-date-time-wrap custom-input-wrap\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tap-tile-date-input\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"calendar-alt\"],null]],[1,\"\\n            \"],[8,[39,9],null,[[\"@value\",\"@defaultDate\",\"@onSelect\",\"@id\"],[[30,0,[\"customDate\"]],[30,0,[\"defaultCustomDate\"]],[28,[37,10],[[28,[37,11],[[30,0,[\"customDate\"]]],null]],null],\"custom-date\"]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"tap-tile-time-input\"],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"far-clock\"],null]],[1,\"\\n            \"],[8,[39,12],[[24,\"placeholder\",\"--:--\"],[24,1,\"custom-time\"],[24,0,\"time-input\"]],[[\"@type\",\"@value\"],[\"time\",[30,0,[\"customTime\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"control-group custom-date-time-wrap custom-relative-wrap\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"control-label\"],[14,\"for\",\"bookmark-relative-time-picker\"],[12],[1,\"\\n            \"],[1,[28,[35,6],[\"relative_time_picker.relative\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,13],null,[[\"@id\",\"@durationMinutes\",\"@onChange\"],[\"bookmark-relative-time-picker\",[30,0,[\"selectedDurationMins\"]],[28,[37,5],[[30,0],\"relativeTimeChanged\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]],null]],[2]],null]],[1]]]]]],[\"grid\",\"option\"],false,[\"tap-tile-grid\",\"each\",\"-track-array\",\"unless\",\"tap-tile\",\"action\",\"i18n\",\"if\",\"d-icon\",\"date-picker-future\",\"fn\",\"mut\",\"input\",\"relative-time-picker\"]]",
  "moduleName": "discourse/components/time-shortcut-picker.hbs",
  "isStrictMode": false
});